import { SentencePractice } from "../../components/SentencePractice.js";
import { Breadcrumb } from "../../components/Breadcrumb.js";
import { ComingSoon } from "../../components/ComingSoon.js";
import { PageSEOSection } from "../../components/PageSEOSection.js";
import { useState, useEffect } from "react";
import { usePageContext } from "vike-react/usePageContext";

export default function Page() {
  const pageContext = usePageContext();
  const language = pageContext.routeParams?.language || 'es';
  const comingSoon = pageContext.routeParams?.comingSoon === 'true';
  
  // Map language code to language name for URL
  const languageNameMap: Record<string, string> = {
    'es': 'spanish',
    'pt': 'portuguese', 
    'fr': 'french',
    'it': 'italian',
    'ca': 'catalan',
    'ro': 'romanian'
  };
  
  const languageName = languageNameMap[language] || 'spanish';
  const languagePrefix = `/learn-${languageName}`;
  const [showControls, setShowControls] = useState<boolean>(false);

  // Show coming soon page for unsupported languages
  if (comingSoon) {
    return <ComingSoon language={language} />;
  }

  return (
    <div className={"max-w-4xl mx-auto px-4"}>
      <Breadcrumb 
        items={[{ name: "Home", url: languagePrefix }]} 
        currentPage="Sentences" 
      />
      <div className="flex items-center justify-between mb-3">
        <h1 className={"font-bold text-xl sm:text-2xl text-gray-900 dark:text-gray-100"}>
          Sentence Building Practice — Learn {language === "es" ? "Spanish" : "Portuguese"} Writing
        </h1>
        <button
          type="button"
          onClick={() => setShowControls(!showControls)}
          className="text-sm px-4 py-2 rounded-lg border border-gray-200 dark:border-gray-800 bg-gray-100 dark:bg-white/10 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-gray-100 transition-colors min-h-[44px]"
        >
          {showControls ? "Hide Controls" : "Show Controls"}
        </button>
      </div>

      <SentencePractice showControls={showControls} language={language} />
      <PageSEOSection pageType="sentences" languageName={languageName} />
    </div>
  );
}


